import React, { useState } from "react";
import { Container, Carousel, Row, Col } from "react-bootstrap";

const data = [
  {
    id: 1,
    title: "Understand the App Context",
    description:
      "We begin by understanding the purpose of the app, who it is meant for, and how it needs to function in day-to-day use.",
  },
  {
    id: 2,
    title: "Define the Right Platform Approach",
    description:
      "Based on product needs, we shape the right path for iOS, Android or cross-platform development.",
  },
  {
    id: 3,
    title: "Build Around Real Usage and Performance",
    description:
      "Development focuses on usability, responsiveness, and how the application behaves under real usage conditions.",
  },
  {
    id: 4,
    title: "Test, Refine and Prepare for Release",
    description:
      "The app is reviewed across devices, refined through testing, and prepared for a stable rollout.",
  },
  {
    id: 5,
    title: "Support What Comes Next",
    description:
      "Once live, we continue improving the app through updates, fixes and ongoing enhancements as needs evolve.",
  },
];

// Function to group items per slide
const chunkArray = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

export default function ApproachCarousel() {
  const [index, setIndex] = useState(0);

  const itemsPerSlide = 3;
  const slides = chunkArray(data, itemsPerSlide);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <section className="padding-section-large approach-section bg-dark text-white">
      <Container>
        {/* Header */}

        <Row className='mb-4 pt-5 align-items-end mb-5'>
          <Col md={10}>
            <h2 className="heading-style-h2 pb-3">How We Approach<span className="text-gradient-1">Mobile App Development</span></h2>
            <h5 className='heading-style-h5'>Focused on how the app is used, how it performs, and how it evolves after release.</h5>
          </Col>
          <Col md={2}>
            <div className="carousel-controls pb-3">
              <button className="nav-btn" onClick={() =>
                setIndex((index - 1 + slides.length) % slides.length)
              }>
                ‹
              </button>
              <button className="nav-btn" onClick={() => setIndex((index + 1) % slides.length)}>
                ›
              </button>
            </div>
          </Col>
        </Row>
        {/* Carousel */}
        <Carousel
          activeIndex={index}
          onSelect={handleSelect}
          controls={false}
          indicators={false}
          interval={null}
        >
          {slides.map((slide, slideIndex) => (
            <Carousel.Item key={slideIndex}>
              <Row>
                {slide.map((item) => (
                  <Col md={4} key={item.id} className="mb-4">
                    <div className="approach-card d-flex justify-content-between flex-column">
                      <div>
                        <h4 className="heading-style-h4 text-gradient-1">{item.id}</h4>
                        <h4 className="heading-style-h4 pb-5">{item.title}</h4>
                      </div>
                      <p>{item.description}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
        <Row>
          <div className='bg-gradient-2 text-white p-4 mx-auto text-center w-auto mt-5'>
            <p className='mb-0'>The goal is not just to launch an app, but to make sure it stays reliable and easy to use over time.</p>
          </div>
        </Row>
      </Container>
    </section >
  );
}